import { MenuButton } from 'aria-components';
import { keyCodes } from 'aria-components/utils';

/**
 * Component for milestones jump to decade.
 */
export default class MilestonesJumpToDecade {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);
    this.onMenuSelect = this.onMenuSelect.bind(this);
    this.handleJumpMenuClick = this.handleJumpMenuClick.bind(this);
    this.handleJumpMenuKeydown = this.handleJumpMenuKeydown.bind(this);

    this.init();
  }

  /**
   * Handle jump menu keydown.
   *
   * @param {Event} event The event object.
   */
  handleJumpMenuKeydown(event) {
    const { RETURN } = keyCodes;

    if (RETURN === event.keyCode && 'A' === event.target.nodeName) {
      event.preventDefault();
      this.onMenuSelect(event.target);
    }
  }

  /**
   * Handle jump menu clicks.
   *
   * @param {Event} event The event object.
   */
  handleJumpMenuClick(event) {
    if ('A' === event.target.nodeName) {
      event.preventDefault();
      this.onMenuSelect(event.target);
    }
  }

  /**
   * Close the MenuButton Popup when a link is activated.
   *
   * @param  {HTMLAnchorElement} eventTarget The event target.
   */
  onMenuSelect(eventTarget) {
    const { hash } = eventTarget;
    const { state } = window.history;
    const baseUrl = new URL(window.location);

    // Update the hash, which also updates the href.
    baseUrl.hash = hash;
    // Update the page location.
    window.location.href = baseUrl.href;

    window.history.replaceState(state, '', baseUrl);
    this.menuButton.hide();
  }

  /**
   * Set up the dropdown as a MenuButton.
   */
  init() {
    const { controller, target } = this.children;

    // Initialize the MenuButton class.
    this.menuButton = new MenuButton({ controller, target });

    target.addEventListener('click', this.handleJumpMenuClick);
    target.addEventListener('keydown', this.handleJumpMenuKeydown);
  }
}
